import {IComparisonCondition} from './comparison-operators';
import {ILogicalCondition} from './logical-operators';

export enum arrayOperators {
    some = 'some', // Array.some
    every = 'every', // Array.every
    none = 'none'
}

export interface IArrayCondition {
    operator: arrayOperators;
    propertyPath: string; // left operand
    condition: IArrayCondition | IComparisonCondition | ILogicalCondition; // callback condition
}
